/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
// import { setCurrentUser } from "../store/actions/authActions.js";
import { NavLink } from "react-router-dom";
import { Button, Checkbox, Modal } from "flowbite-react";
import TableSearchBar from "../../components/TableSearchBar";
import instance, { fetchAllDepartments } from "../../api/api";
import { Loader } from "../../components/Loader";
import PerspectiveBadge from "../../components/PerspectiveBadge";
import GetScoreColor from "../../utils/GetScoreColor";
import { getRiskScoreColorClass } from "../../utils/riskLevel";
import { useTenant } from "../../context/Tenant/TenantContext";
import { usePostHog } from "@posthog/react";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
  getSortedRowModel,
  SortingState,
} from "@tanstack/react-table";

type Risk = {
  id: string;
  riskNumber: string;
  riskName: string;
  perspective: string;
  description: string;
  source: string;
  rootCause: string;
  objective: string;
  riskConsequence: string;
  responseText: string;
  inherentRiskScore: number;
  residualRiskScore: number;
  RiskRegisterUserScore: any;
  RiskResponseUserScore: any;
};

function AdminRiskResponseFinalization() {
  const { config, loading: tenantLoading } = useTenant();
  const posthog = usePostHog();
  // const [moreDetailsRequested, setMoreDetailsRequested] = useState(false);
  const [moveRisksModal, setMoveRisksModal] = useState(false);

  const [currentRiskDetails, setCurrentRiskDetails] = useState<any>([]);
  const [isLoadingRisks, setIsLoadingRisks] = useState(false);
  const [allRisks, setAllRisks] = useState<any>([]);
  const [isSubmittingResponseTextScore, setIsSubmittingResponseTextScore] =
    useState(false);

  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);

  const [isApprovingRisks, setIsApprovingRisks] = useState(false);

  const [departments, setDepartments] = useState<any[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");

  const [riskScores, setRiskScores] = useState<[string, string][]>([]);
  const [highlightedRiskId, setHighlightedRiskId] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [sorting, setSorting] = useState<SortingState>([
    { id: "residualRiskScore", desc: true },
  ]);
  const [selectedRiskIds, setSelectedRiskIds] = useState<string[]>([]);

  const closeDrawerRef = useRef<any>(null);

  useEffect(() => {
    if (!config) return;
    if (config?.Acceptance) setRiskScores(Object.entries(config.Acceptance));
  }, [config]);

  useEffect(() => {
    const fetchDepartments = async () => {
      setDepartments(await fetchAllDepartments());
    };
    fetchDepartments();
  }, []);

  useEffect(() => {
    posthog?.capture("page_viewed", { page: "admin_risk_response_finalization" });
  }, [posthog]);

  const getAllRisks = async () => {
    try {
      setIsLoadingRisks(true);
      let riskRegisterResponse;
      if (selectedDepartment === "" || selectedDepartment === "All") {
        riskRegisterResponse = await instance.get(
          "/api/admin/riskRegister/riskRegisters/selections/SELECTION_COMPLETE"
        );
      } else {
        riskRegisterResponse = await instance.get(
          `/api/admin/riskRegister/riskRegisters/department?departmentName=${selectedDepartment}`
        );
      }
      const riskResponse = await instance.get(
        "/api/admin/riskResponse/riskResponses/all/PLAN_UNDER_REVIEW"
      );

      let riskManagements: any;
      try {
        const riskManagement = await instance.get(
          "/api/admin/riskManagement/riskManagements/all"
        );
        riskManagements =
          riskManagement && riskManagement.data ? riskManagement.data.data : [];
      } catch (error: any) {
        if (error.response && error.response.status === 404) {
          console.warn("Risk management not found, continuing without them.");
        } else {
          throw error;
        }
      }

      const riskRegister = riskRegisterResponse.data.data ?? [];
      const riskResponses = riskResponse.data.data ?? [];
      const riskWithInherentRisk = riskResponse.data.dataWithInherentRisk ?? [];
      setIsLoadingRisks(false);

      const combinedRisks = riskResponses.map((riskResponse: any) => {
        const risks = riskRegister.find(
          (risk: any) => riskResponse.riskRegisterId === risk.id
        );
        return {
          ...riskResponse,
          riskName: risks?.riskName,
          riskNumber: risks?.riskNumber,
          perspective: risks?.perspective,
          objective: risks?.objective,
          responseId: riskResponse ? riskResponse.id : "",
          RiskRegisterUserScore:
            risks && risks.RiskRegisterUserScore
              ? risks.RiskRegisterUserScore[
                  risks.RiskRegisterUserScore.length - 1
                ]
              : [],
          RiskResponseUserScore: riskResponse
            ? riskResponse.RiskResponseUserScore[
                riskResponse.RiskResponseUserScore.length - 1
              ]
            : [],
          riskConsequence: riskResponse ? riskResponse.riskConsequence : "--",
          responseText: riskResponse ? riskResponse.responseText : "--",
          // responseTextScore: responses ? responses.responseTextScore : 0,
          // riskConsequenceScore: responses ? responses.riskConsequenceScore : 0,
        };
      }).filter((risk: any) =>
        risk.riskName &&
        risk.riskNumber &&
        risk.perspective &&
        risk.objective &&
        risk.RiskResponseUserScore &&
        (risk.RiskResponseUserScore.responseTextScore > 0 ||
          risk.RiskResponseUserScore.riskConsequenceScore > 0)
      );;

      // Filter out risks that are present in risk management
      const filteredRisks = combinedRisks.filter((risk: any) =>
        riskManagements
          ? !riskManagements.some(
              (management: any) => management.riskRegisterId === risk.riskRegisterId
            )
          : combinedRisks
      );

      const risksWithCumulativeScore = filteredRisks.map((risk: any) => {
        const scores = riskWithInherentRisk.find(
          (score: any) => score.riskRegisterId === risk.riskRegisterId
        );
        return {
          ...risk,
          inherentRiskScore: scores?.inherentRiskScore
            ? scores.inherentRiskScore
            : 0,
          residualRiskScore: scores?.residualRiskScore
            ? scores.residualRiskScore
            : 0,
        };
      });

      // sort risks by descending order of inherent risk score
      risksWithCumulativeScore.sort(
        (a: any, b: any) => b.residualRiskScore - a.residualRiskScore
      );

      setAllRisks(risksWithCumulativeScore);
    } catch (error) {
      setIsLoadingRisks(false);
      console.error(error);
    }
  };
  useEffect(() => {
    getAllRisks();
  }, [selectedDepartment]);

   // A row is complete if all required fields are present and non-empty
  const isRiskComplete = (risk: Risk) =>
    Boolean(risk.responseText && risk.responseText.trim() !== "" && risk.responseText !== "--");

  const toggleSelect = (id: string) => {
    const risk = allRisks.find((r: any) => r.id === id);
    if (!risk || !isRiskComplete(risk)) return;
    setSelectedRiskIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleScoreResponseDrawer = (riskId: string) => {
    const risk = allRisks.find((risk: Risk) => risk.id === riskId);
    setIsEditDrawerOpen(true);
    setCurrentRiskDetails(risk);
    setHighlightedRiskId(riskId);
  };

  const handleScoreResponseText = async (e: any) => {
    e.preventDefault();
    setIsSubmittingResponseTextScore(true);

    try {
      // First API call: Save the response score
      await instance.post(
        `/api/employee/riskResponse/score/create/${currentRiskDetails.responseId}`,
        {
          suggestion: currentRiskDetails.suggestion,
          responseTextScore: currentRiskDetails.responseTextScore
            ? Number(currentRiskDetails.responseTextScore)
            : 0,
        }
      );

      // Second API call: Save the action plan if it exists and is not empty
      if (currentRiskDetails.responseText && currentRiskDetails.responseText.trim() !== "") {
        await instance.post(
          `/api/employee/riskResponse/create/${currentRiskDetails.riskRegisterId}`,
          {
            responseText: currentRiskDetails.responseText,
            riskConsequence: currentRiskDetails.riskConsequence
            ? currentRiskDetails.riskConsequence
            : "",
          }
        );
      }

      if (closeDrawerRef.current) {
        closeDrawerRef.current.click();
      }
      setIsSubmittingResponseTextScore(false);
      await getAllRisks();
    } catch (error) {
      setIsSubmittingResponseTextScore(false);
      return error;
    }
  };

  const editDrawerRef = useRef<any>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        editDrawerRef.current &&
        !editDrawerRef.current.contains(event.target)
      ) {
        setIsEditDrawerOpen(false);
        setHighlightedRiskId(null);
      }
    };

    if (isEditDrawerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      setHighlightedRiskId(null);
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditDrawerOpen]);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  // Calculate the items to display based on the current page and items per page
  const paginatedRisks = React.useMemo(() => {
    let risksToDisplay = allRisks;

    // Apply search filter
    if (searchTerm) {
      risksToDisplay = risksToDisplay.filter((risk: any) =>
        Object.values(risk).some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return risksToDisplay.slice(indexOfFirstItem, indexOfLastItem);
  }, [allRisks, currentPage, itemsPerPage, searchTerm]);

  const totalPages = Math.ceil(allRisks.length / itemsPerPage);

  const handleMoveRisksToNextStage = async () => {
    setIsApprovingRisks(true);
    try {
      for (const risk of allRisks) {
        if (risk.RiskResponseUserScore.responseTextScore !== 0) {
          await instance.put(
            `/api/admin/riskResponse/update/status/${risk.responseId}`,
            {
              status: "RESPONSE_APPROVED",
            }
          );

          await instance.post(
            `/api/admin/riskManagement/riskManagements/create/${risk.riskRegisterId}`,
            {
              riskManagementPlan: "--",
              actionOwner: "--",
              deadline: new Date(),
              monitaringDate: null,
              completionDate: null,
            }
          );
        }
      }
      setIsApprovingRisks(false);
      posthog?.capture("risk_response_finalized", { risksCount: allRisks.length });
      window.location.reload();
    } catch (error) {
      setIsApprovingRisks(false);
      console.error(error);
    }
  };

  const columnHelper = createColumnHelper<Risk>();
  const columns = [
    columnHelper.accessor("riskNumber",{
          header: () => <span className="whitespace-nowrap">Risk Number</span>,
          cell: (info) => {
            const id = info.row.original.id;
            const complete = isRiskComplete(info.row.original);
            return (
              <span className="whitespace-nowrap font-bold">
                <span className="mr-2">
                  {complete && (
                    <Checkbox
                aria-label="Select risk"
                className={`h-4 w-4 ${complete ? "" : "opacity-50 cursor-not-allowed"}`}
                checked={selectedRiskIds.includes(id)}
                onChange={() => toggleSelect(id)}
              />
                  )}
                </span>
                {info.getValue()}
              </span>
            );
          },
        }),
    columnHelper.accessor("riskName", {
      header: () => <span className="whitespace-nowrap">Risk Name</span>,
      cell: (info) => info.getValue(),
      enableSorting: true,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("perspective", {
      header: () => "Perspective",
      cell: (info) => <PerspectiveBadge value={info.getValue()} />,
      enableSorting: true,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("objective", {
      header: () => "Objective",
      cell: (info) => info.renderValue(),
      enableSorting: true,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("responseText", {
      header: () => <span className="whitespace-nowrap">Risk Response</span>,
      cell: (info) => info.getValue(),
      enableSorting: true,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("inherentRiskScore", {
      header: () => <span className="">Inherent Risk Score</span>,
      cell: (info) => <div className="text-center">{info.renderValue()}</div>,
      enableSorting: true,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("residualRiskScore", {
      header: () => <span className="">Residual Risk Score</span>,
      cell: (info) => (
        <div
          className={`text-center ${getRiskScoreColorClass(info.row.original.residualRiskScore, config?.RiskLevels)}`}
        >
          {info.getValue()}
        </div>
      ),
      enableSorting: true,
      footer: (info) => info.column.id,
    }),
    columnHelper.display({
      id: "actions",
      header: () => <span>Actions</span>,
      enableSorting: false,
      cell: ({ row }) => (
        <button
          type="button"
          className="w-auto flex justify-center text-caribbeanCurrent items-center hover:text-black hover:bg-white hover:border-2 hover:border-caribbeanCurrent border border-caribbeanCurrent hover:bg-caribbeanCurrent focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-4 py-2 text-center inline-flex me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-blue-800 border-caribbeanCurrent text-black hover:bg-blue-800 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          data-drawer-target="drawer-assessment-risk-response"
          data-drawer-show="drawer-assessment-risk-response"
          data-drawer-placement="right"
          aria-controls="drawer-assessment-risk-response"
          onClick={() => handleScoreResponseDrawer(row.original.id)}
        >
          <svg
            className="w-4 h-4 text-white-800 dark:text-white me-2"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
          Edit
        </button>
      ),
    }),
  ];

  const table = useReactTable<Risk>({
    data: paginatedRisks,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: { sorting },
    onSortingChange: setSorting,
  });

  if (tenantLoading || !config) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader size="xl" />
      </div>
    );
  }

  return (
    <>
      {/* <!-- Breadcrumb --> */}
      <nav
        className="justify-between  py-3 text-gray-700  sm:flex bg-gray-50"
        aria-label="Breadcrumb"
      >
        <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0">
          <li>
            <div className="flex items-center">
              <NavLink
                to=""
                className=" text-sm font-medium text-gray-700 hover:text-blue-600  dark:text-gray-400 dark:hover:text-white"
              >
                Risk Response
              </NavLink>
            </div>
          </li>

          <li aria-current="page">
            <div className="flex items-center ">
              <svg
                className="rtl:rotate-180 w-3 h-3 mx-1 text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span className="mx-1 text-sm font-medium text-gray-500 md:mx-2 dark:text-gray-400">
                Response Finalization
              </span>
            </div>
          </li>
        </ol>
      </nav>
      <h1 className="text-xl mb-3 font-semibold text-gray-700">
        Risk Response Finalization
      </h1>
      <form className="flex max-w-sm my-4 justify-center items-center">
        <label
          htmlFor="countries"
          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        >
          Department
        </label>
        <select
          id="countries"
          className="ml-5 bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          onChange={(e) => setSelectedDepartment(e.target.value)}
        >
          <option>All</option>
          {departments &&
            departments.map((department, index) => (
              <option key={index}>{department.name}</option>
            ))}
        </select>
      </form>

      <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4">
        <div className="p-5 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white dark:text-white dark:bg-gray-800 sticky top-0 z-20">
          <div className="w-full flex items-center justify-between">
            <p>Department Risks</p>
            <div className="flex flex-row gap-4 items-center justify-center">
              <div className="">
                <TableSearchBar
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                  placeholder="Search risks..."
                />
              </div>
            </div>
          </div>
        </div>
        <div className="rt-wrap relative sm:rounded-lg max-h-[calc(100vh-300px)] overflow-y-auto">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-sm text-jet font-bold bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0 z-10">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    const isSorted = header.column.getIsSorted();
                    const isActionsColumn = header.column.id === "actions";
                    return (
                      <th
                        scope="col"
                        key={header.id}
                        className={`px-6 py-3 ${
                          isActionsColumn
                            ? "sticky right-0 bg-gray-50 dark:bg-gray-700 z-10"
                            : ""
                        }`}
                        aria-sort={
                          isSorted === "asc"
                            ? "ascending"
                            : isSorted === "desc"
                            ? "descending"
                            : "none"
                        }
                      >
                        {header.isPlaceholder ? null : (
                          <button
                            type="button"
                            className={`flex items-center gap-1 select-none ${
                              header.column.getCanSort()
                                ? "cursor-pointer"
                                : "cursor-default"
                            }`}
                            onClick={header.column.getToggleSortingHandler()}
                            title={
                              header.column.getCanSort() ? "Sort" : undefined
                            }
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                            {header.column.getCanSort() && (
                              <span className="text-xs">
                                {isSorted === "asc"
                                  ? "▲"
                                  : isSorted === "desc"
                                  ? "▼"
                                  : "⇅"}
                              </span>
                            )}
                          </button>
                        )}
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            {isLoadingRisks ? (
              <tbody>
                <tr className="text-center">
                  <td colSpan={7} className="text-center">
                    <div className="flex justify-center items-center h-96">
                      <Loader size={"xl"} />
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="text-jet font-medium text-xs">
                {table.getRowModel().rows.map((row) => (
                  <>
                    <tr
                      key={row.id}
                      className={`bg-gray hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 ${
                        highlightedRiskId === row.original.id
                          ? "bg-gray-200"
                          : ""
                      }`}
                    >
                      {row.getVisibleCells().map((cell) => {
                        const isActionsColumn = cell.column.id === "actions";
                        return (
                          <td
                            className={`px-6 py-4 align-top ${
                              isActionsColumn
                                ? "sticky right-0 bg-white dark:bg-gray-800"
                                : ""
                            }`}
                            key={cell.id}
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )}
                          </td>
                        );
                      })}
                    </tr>

                    <tr className="bg-transparent">
                      {row.getVisibleCells().map((cell) => {
                        const isActionsColumn = cell.column.id === "actions";
                        return (
                          <td
                            className={`px-6 py-2 border-b text-gray-500 text-xs bg-transparent ${
                              isActionsColumn
                                ? "sticky right-0 bg-white dark:bg-gray-800"
                                : ""
                            }`}
                            key={`${cell.id}-score`}
                          >
                            {cell.column.id === "riskConsequence" && (
                              <div className="font-bold text-gray-500">
                                Score:{" "}
                              <span
                                className={GetScoreColor(
                                  row.original.RiskResponseUserScore
                                    .riskConsequenceScore
                                )}
                              >
                                {
                                  row.original.RiskResponseUserScore
                                    .riskConsequenceScore
                                }
                              </span>
                            </div>
                          )}

                          {cell.column.id === "responseText" && (
                            <div className="font-bold text-gray-500 whitespace-nowrap">
                              Response Rating:{" "}
                              <span
                                className={GetScoreColor(
                                  row.original.RiskResponseUserScore
                                    .responseTextScore
                                )}
                              >
                                {
                                  row.original.RiskResponseUserScore
                                    .responseTextScore
                                }
                              </span>
                            </div>
                          )}
                        </td>
                        );
                      })}
                    </tr>
                  </>
                ))}
              </tbody>
            )}
          </table>

          {/* Pagination */}
          <div className="mt-4 pl-10 pr-10 pb-5 text-jet font-medium text-xs ">
            <nav aria-label="Page navigation">
              <ul className="flex justify-between">
                <li className="flex flex-row items-center">
                  <div>
                    <p>Show rows per page</p>
                  </div>
                  <div>
                    <select
                      className="ml-2 bg-gray-50 border border-caribbeanCurrent text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    >
                      <option>25</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                  </div>
                </li>
                <li className="flex flex-row gap-1 items-center text-gray-500">
                  <div>
                    <p>
                      {currentPage} of {totalPages === 0 ? 1 : totalPages}
                    </p>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      {"<"}
                    </button>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      {">"}
                    </button>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* drawers */}

      {/* Edit item risk */}
      {allRisks.length > 0 && (
        <div
          id="drawer-assessment-risk-response"
          ref={editDrawerRef}
          className={`fixed top-0 right-0 z-50 h-screen p-4 overflow-y-auto transition-transform ${
            isEditDrawerOpen ? "translate-x-0" : "translate-x-full"
          } bg-white w-full md:w-1/4 dark:bg-gray-800`}
          tabIndex={-1}
          aria-labelledby="drawer-assessment-risk-response-label"
        >
          <h5
            id="drawer-label"
            className="inline-flex items-center mb-6 text-base font-semibold text-gray-500  dark:text-gray-400"
          >
            Risk Response Scoring
          </h5>
          <button
            type="button"
            data-drawer-hide="drawer-assessment-risk-response"
            aria-controls="drawer-assessment-risk-response"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
            ref={closeDrawerRef}
            onClick={() => setIsEditDrawerOpen(false)}
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close menu</span>
          </button>
          <form
            onSubmit={handleScoreResponseText}
            className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4 p-4"
          >
            <div className="mb-6">
              <label
                htmlFor="responseText"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Response
              </label>
              <textarea
                id="responseText"
                rows={4}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk Response goes here..."
                value={
                  currentRiskDetails &&
                  currentRiskDetails.responseText &&
                  currentRiskDetails.responseText !== "--"
                    ? currentRiskDetails.responseText
                    : ""
                }
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    responseText: e.target.value,
                  }));
                }}
              ></textarea>
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskGoals"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Select Rating
              </label>
              <select
                id="riskGoals"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  setCurrentRiskDetails((prevState: any) => ({
                    ...prevState,
                    responseTextScore: e.target.value,
                  }));
                }}
              >
                <option>Select Rating</option>
                {riskScores.map(([score, name]) => (
                  <option value={score} key={score}>
                    {score} {name}
                  </option>
                ))}
              </select>
            </div>
            {currentRiskDetails.responseTextScore <= 2 && (
              <div className="mb-6">
                <label
                  htmlFor="suggestion"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Your suggestion
                </label>
                <textarea
                  id="suggestion"
                  rows={4}
                  className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter your suggestion here"
                  onChange={(e) => {
                    setCurrentRiskDetails((prevState: any) => ({
                      ...prevState,
                      suggestion: e.target.value,
                    }));
                  }}
                ></textarea>
              </div>
            )}

            <div className="flex gap-4">
              <button
                disabled={isSubmittingResponseTextScore}
                type="submit"
                className={`justify-center items-center inline-flex text-white bg-caribbeanCurrent hover:bg-blue-800 w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block ${
                  isSubmittingResponseTextScore
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                onClick={handleScoreResponseText}
              >
                {isSubmittingResponseTextScore ? (
                  <Loader size="sm" />
                ) : (
                  "Submit Rating"
                )}
              </button>

              <button
                className="justify-center items-center inline-flex text-black border-2 border-caribbeanCurrent hover:bg-caribbeanCurrent hover:text-white w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block"
                onClick={(e) => {
                  e.preventDefault();
                  setIsEditDrawerOpen(false);
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="border-red-300 dark:border-gray-600 h-54 mb-4">
        <div className="space-y-6">
          {/* <h3 className="text-riskRed font-medium text-lg">
            Move Risks To Risk Monitoring Stage
          </h3> */}
          <Button
            onClick={() => setMoveRisksModal(true)}
            className="bg-riskRed font-bold"
            disabled={selectedRiskIds.length === 0}
          >
            Move Risks
          </Button>
          <Modal
            dismissible
            show={moveRisksModal}
            size="xl"
            onClose={() => setMoveRisksModal(false)}
            popup
          >
            {/* <Modal dismissible show={openModal} onClose={() => setOpenModal(false)}> */}
            <Modal.Header className="ml-3 p-5 border-b">
              <h4 className="font-bold text-gray-700 dark:text-gray-400">
                Move Risks To Risk Monitoring Stage
              </h4>
            </Modal.Header>
            <Modal.Body>
              <div className="space-y-5 p-3">
                <p className="text-base leading-relaxed text-gray-700 dark:text-gray-400">
                  Are you sure you want to promote these risks to the next
                  stage?
                </p>
                <p className="text-base leading-relaxed text-gray-700 dark:text-gray-400">
                  <span className="font-bold">Note: </span> You can't undo this
                  action
                </p>
              </div>
            </Modal.Body>
            <Modal.Footer className="border-t">
              <Button
                color="gray"
                className="border-none text-riskRed"
                onClick={() => setMoveRisksModal(false)}
              >
                Cancel
              </Button>
              <Button
                className="bg-riskRed hover:bg-riskRed"
                onClick={() => {
                  handleMoveRisksToNextStage();
                }}
              >
                {isApprovingRisks ? <Loader size="sm" /> : "Confirm"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default connect()(AdminRiskResponseFinalization);
